module.exports = __webpack_public_path__ + "static/media/blog-6.975c02d4.jpg";